"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _userflow = require("../../utils/userflow");

var _Button = _interopRequireDefault(require("../Button"));

var _HotelRoomName = _interopRequireDefault(require("./HotelRoomName"));

var _HotelRoomFacilities = _interopRequireDefault(require("./HotelRoomFacilities"));

var _LabelList = require("../Label/LabelList");

var _hotel = require("../../proptypes/hotel");

var _excluded = ["roomName", "originalName", "area", "description", "facilities", "hotelFacilities", "labels"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HotelRoomDescription = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(HotelRoomDescription, _React$PureComponent);

  var _super = _createSuper(HotelRoomDescription);

  function HotelRoomDescription(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, HotelRoomDescription);
    _this = _super.call(this, props);
    _this.state = {
      showMore: undefined
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleOverflow = _this.handleOverflow.bind((0, _assertThisInitialized2["default"])(_this));

    _this.onShowMore = function () {
      return _this.setState({
        showMore: false
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(HotelRoomDescription, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observer = new _resizeObserverPolyfill["default"](this.handleOverflow);
      this.observer.observe(this.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.unobserve(this.container);
      }
    }
  }, {
    key: "handleOverflow",
    value: function handleOverflow() {
      var showMore = this.state.showMore;

      if (showMore !== false) {
        var isOverflown = (0, _userflow.isElementOverflown)(this.container);
        this.setState({
          showMore: isOverflown || undefined
        });
      }
    }
  }, {
    key: "container",
    get: function get() {
      return (0, _get2["default"])(this, 'containerRef.current');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          roomName = _this$props.roomName,
          originalName = _this$props.originalName,
          area = _this$props.area,
          description = _this$props.description,
          facilities = _this$props.facilities,
          hotelFacilities = _this$props.hotelFacilities,
          labels = _this$props.labels,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var showMore = this.state.showMore;
      return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescription, (0, _extends2["default"])({}, rest, {
        ref: this.containerRef
      }), /*#__PURE__*/_react["default"].createElement(_HotelRoomName["default"], {
        name: roomName,
        originalName: originalName,
        area: area
      }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
        labels: labels,
        maxLabels: 6
      }), /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescriptionWrapper, {
        expanded: showMore === false
      }, /*#__PURE__*/_react["default"].createElement(_HotelRoomFacilities["default"], {
        description: description,
        facilities: facilities
      }), hotelFacilities && /*#__PURE__*/_react["default"].createElement(StyledFacilitiesHintButton, {
        "data-hint-room-facilities": true,
        functional: true
      }, _localization.i18n.t('hotel.room.facilities'))), showMore && /*#__PURE__*/_react["default"].createElement(ShowMoreContainer, null, /*#__PURE__*/_react["default"].createElement(ShowMoreButton, {
        onClick: this.onShowMore
      }, _localization.i18n.t('hotel.room.moreButton'))));
    }
  }]);
  return HotelRoomDescription;
}(_react["default"].PureComponent);

HotelRoomDescription.defaultProps = {
  originalName: null,
  area: null,
  description: null,
  facilities: null,
  hotelFacilities: null,
  labels: []
};
HotelRoomDescription.propTypes = {
  roomName: _propTypes["default"].string.isRequired,
  originalName: _propTypes["default"].string,
  area: _propTypes["default"].number,
  description: _propTypes["default"].string,
  facilities: _propTypes["default"].arrayOf(_hotel.RoomFacilityPropTypes),
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.HotelFacilityPropTypes),
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelRoomDescription__StyldLabelList",
  componentId: "sc-1wjft0c-0"
})(["margin-top:8px;> div:last-child{margin-bottom:0;}"]);

var StyledHotelRoomDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledHotelRoomDescription",
  componentId: "sc-1wjft0c-1"
})(["position:relative;overflow:hidden;background:", ";"], function (props) {
  return props.theme.colors.white;
});

var ShowMoreContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__ShowMoreContainer",
  componentId: "sc-1wjft0c-2"
})(["position:absolute;width:100%;bottom:0;left:0;padding-top:30px;background-image:linear-gradient( to bottom,rgba(255,255,255,0),", " 30% );"], function (props) {
  return props.theme.colors.white;
});

var ShowMoreButton = (0, _styledComponents["default"])(_Button["default"]).attrs({
  size: 'tiny'
}).withConfig({
  displayName: "HotelRoomDescription__ShowMoreButton",
  componentId: "sc-1wjft0c-3"
})(["background:", ";font-size:13px;max-width:170px;"], function (props) {
  return props.theme.colors.white;
});

var StyledHotelRoomDescriptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomDescription__StyledHotelRoomDescriptionWrapper",
  componentId: "sc-1wjft0c-4"
})(["margin-top:8px;position:", ";"], function (props) {
  return props.expanded ? 'relative' : 'absolute';
});

var StyledFacilitiesHintButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelRoomDescription__StyledFacilitiesHintButton",
  componentId: "sc-1wjft0c-5"
})(["color:", ";margin-top:20px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
});
var _default = HotelRoomDescription;
exports["default"] = _default;